import { makeAutoObservable } from 'mobx';
import t from 'counterpart';
import { merge } from 'lodash';
import {toast} from '../services'

const defaultConfirmation = () => ( {
  id                  : 'mpk-modal-confirmation',
  visible             : false,
  title               : '',
  children            : '',
  onSubmit            : null,
  dialogStyle         : null,
  submitLabel         : null,
  cancelLabel         : null
})

const defaultInformation = () => ({
  id                  :'mpk-modal-information',
  visible             : false,
  title               : '',
  children            : '',
  dialogStyle         : null
})

class ModalStore{
  confirmation = defaultConfirmation()
  information = defaultInformation()

  closeConfirm(){
    this.confirmation.visible = false
  }

  showConfirm({
    title       = t.translate('mpk.confirm.title'),
    children    = t.translate('mpk.config.message'),
    onSubmit    = () => {},
    dialogStyle = null
  }){
    this.confirmation = merge(defaultConfirmation(), {
      visible : true,
      title, children, dialogStyle
    })
    this.confirmation.onSubmit = (callback) => {
      onSubmit((response, asError=false, autoClose=true) => {
        if(response) {
          if(asError) {
            if(typeof response === 'string') toast.error(response)
            else toast.errorRequest(response);
          } else if(response && typeof response === 'string') toast.success(response)
        }
        if(autoClose)this.confirmation.visible = false
        callback()
      })
    }
    
  }

  closeInfo(){
    this.information.visible = false
  }

  showInfo({
    title       = t.translate('mpk.word.info'),
    children    = '',
    dialogStyle = null,
    onRequestClose = () => {},
  }){
    this.information = merge(defaultInformation(), {
      visible: true,
      title, children, dialogStyle,
      onRequestClose
    })
  }

  constructor(){
    makeAutoObservable(this)
  }
}

export default ModalStore;